/* BASE Wellness storefront behaviours: free gift progress, subscribe & save, sticky add to cart. */
(function () {
  'use strict';

  // Dawn declares PUB_SUB_EVENTS with const (not on window); read the global binding.
  var EV = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : null;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function money(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  /* ---------- Free gift progress ---------- */
  function renderGift(el, cart) {
    var threshold = parseInt(el.dataset.threshold, 10) || 0;
    var giftId = parseInt(el.dataset.giftId, 10);
    var label = esc(el.dataset.label || 'gift');
    var spend = 0, inCart = false;
    (cart.items || []).forEach(function (i) {
      if (i.final_line_price === 0 || (giftId && i.product_id === giftId)) inCart = true;
      else spend += i.final_line_price;
    });
    var remaining = threshold - spend;
    var pct = threshold > 0 ? Math.min(100, Math.floor((spend * 100) / threshold)) : 100;
    var unlocked = remaining <= 0;
    var msg;
    if (cart.item_count === 0) msg = 'Spend ' + money(threshold).replace(/\.00$/, '') + ', get a <strong>free ' + label + '</strong>';
    else if (unlocked && inCart) msg = '<strong>Unlocked!</strong> Your free ' + label + ' is in your cart';
    else if (unlocked) msg = '<strong>Unlocked!</strong> Choose your free ' + label;
    else msg = "You're " + money(remaining) + ' away from a <strong>free ' + label + '</strong>';
    el.style.setProperty('--bw-gift-pct', pct + '%');
    el.classList.toggle('is-unlocked', unlocked);
    var m = el.querySelector('[data-bw-gift-msg]');
    if (m) m.innerHTML = msg;
  }

  var giftTimer;
  function refreshGift() {
    clearTimeout(giftTimer);
    giftTimer = setTimeout(function () {
      var els = document.querySelectorAll('[data-bw-gift]');
      if (!els.length) return;
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { els.forEach(function (el) { renderGift(el, cart); }); })
        .catch(function () {});
    }, 250);
  }

  // Theme cart events (Dawn pubsub) and app-driven cart changes (e.g. the gift app adding the bottle).
  if (typeof window.subscribe === 'function' && EV) {
    window.subscribe(EV.cartUpdate, refreshGift);
  }
  if (window.fetch && !window.__bwFetchWrapped) {
    window.__bwFetchWrapped = true;
    var nativeFetch = window.fetch;
    window.fetch = function (input) {
      var p = nativeFetch.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(function () { refreshGift(); }, function () {});
      } catch (e) {}
      return p;
    };
  }

  /* ---------- Subscribe & save (native selling plans) ---------- */
  function initPurchaseOptions(box) {
    var input = box.querySelector('[data-bw-po-input]');
    var select = box.querySelector('[data-bw-po-plan]');
    var opts = box.querySelectorAll('.bw-po__opt');
    var dataEl = box.querySelector('[data-bw-po-data]');
    var data = {};
    try { data = JSON.parse(dataEl.textContent); } catch (e) {}
    var variantId = box.dataset.variantId;

    function mode() {
      var r = box.querySelector('input[name="bw-po-mode-' + box.dataset.uid + '"]:checked');
      return r ? r.value : 'onetime';
    }
    function update() {
      var m = mode();
      opts.forEach(function (o) { o.classList.toggle('is-on', o.dataset.mode === m); });
      var planId = select ? select.value : box.dataset.defaultPlan;
      input.value = m === 'subscription' ? planId : '';
      var v = data[variantId];
      if (!v) return;
      var one = box.querySelector('[data-bw-po-onetime-price]');
      if (one) one.textContent = money(v.price);
      var plan = v.plans[planId];
      var sub = box.querySelector('[data-bw-po-sub-price]');
      var was = box.querySelector('[data-bw-po-sub-was]');
      if (plan && sub) {
        sub.textContent = money(plan.price);
        if (was) {
          was.textContent = plan.compare > plan.price ? money(plan.compare) : '';
        }
      }
    }
    box.addEventListener('change', update);
    if (typeof window.subscribe === 'function' && EV && EV.variantChange) {
      window.subscribe(EV.variantChange, function (e) {
        if (e && e.data && e.data.variant) { variantId = String(e.data.variant.id); update(); }
      });
    }
    update();
  }

  /* ---------- Sticky add to cart ---------- */
  function initSticky(bar) {
    var form = document.querySelector('product-info product-form form, product-form form[action*="/cart/add"]');
    var btn = form && form.querySelector('[type="submit"]');
    var cta = bar.querySelector('[data-bw-sticky-cta]');
    if (!btn || !cta) return;
    cta.addEventListener('click', function () {
      if (btn.disabled) return;
      btn.click();
    });
    function syncState() {
      cta.disabled = btn.disabled;
      var label = btn.querySelector('span');
      if (label && label.textContent.trim()) cta.textContent = label.textContent.trim();
    }
    new MutationObserver(syncState).observe(btn, { attributes: true, childList: true, subtree: true });
    syncState();
    var footer = document.querySelector('.footer');
    var past = false, nearFooter = false;
    function setVis() { bar.classList.toggle('is-visible', past && !nearFooter); bar.setAttribute('aria-hidden', String(!(past && !nearFooter))); }
    new IntersectionObserver(function (entries) {
      past = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      setVis();
    }).observe(btn);
    if (footer) new IntersectionObserver(function (entries) { nearFooter = entries[0].isIntersecting; setVis(); }).observe(footer);
  }

  /* ---------- Secondary add to cart buttons (proxy the main product form) ---------- */
  function initAtcProxy(cta) {
    if (cta.__bwInit) return;
    var form = document.querySelector('product-info product-form form, product-form form[action*="/cart/add"]');
    var btn = form && form.querySelector('[type="submit"]');
    if (!btn) return;
    cta.__bwInit = true;
    cta.addEventListener('click', function () { if (!btn.disabled) btn.click(); });
    var priceEl = cta.closest('.bw-details__buy') && cta.closest('.bw-details__buy').querySelector('[data-bw-atc-price]');
    function sync() {
      cta.disabled = btn.disabled;
      cta.classList.toggle('loading', btn.classList.contains('loading'));
      var label = btn.querySelector('span');
      if (label && label.textContent.trim()) cta.textContent = label.textContent.trim();
    }
    new MutationObserver(sync).observe(btn, { attributes: true, childList: true, subtree: true });
    sync();
    if (priceEl && typeof window.subscribe === 'function' && EV && EV.variantChange) {
      window.subscribe(EV.variantChange, function (e) {
        if (e && e.data && e.data.variant) priceEl.textContent = money(e.data.variant.price);
      });
    }
  }

  /* ---------- Cart drawer gift bar (injected so Dawn's cart-drawer snippet stays untouched) ---------- */
  function injectDrawerGift() {
    var tpl = document.getElementById('BwGiftDrawerTemplate');
    var drawer = document.querySelector('cart-drawer');
    if (!tpl || !drawer) return;
    var header = drawer.querySelector('.drawer__header');
    if (!header || drawer.querySelector('[data-bw-gift]')) return;
    header.insertAdjacentElement('afterend', tpl.content.firstElementChild.cloneNode(true));
    refreshGift();
  }
  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.__bwWatched) return;
    drawer.__bwWatched = true;
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(injectDrawerGift, 30); }).observe(drawer, { childList: true, subtree: true });
    injectDrawerGift();
  }

  function init() {
    watchDrawer();
    document.querySelectorAll('[data-bw-po]').forEach(initPurchaseOptions);
    document.querySelectorAll('[data-bw-sticky]').forEach(initSticky);
    document.querySelectorAll('[data-bw-atc-proxy]').forEach(initAtcProxy);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
